// A history restore invalidates resource loads started by ordinary UI actions too.
let epoch = 0;
export const navigationEpoch = () => epoch;
export const invalidateNavigationLoads = () => { epoch += 1; };
